module.exports = __webpack_public_path__ + "img/HintButtonUP.c1ec1984.png";